import React, { forwardRef, type PropsWithChildren } from 'react';

import styles from './MatchesContainer.module.scss';

type MatchesContainerProps = {
  style?: React.CSSProperties;
};

const MatchesContainer = forwardRef<HTMLUListElement, PropsWithChildren<MatchesContainerProps>>(({
  children,
  style,
}, ref) => {
  return (
    <ul ref={ref}
        style={style}
        className={styles.matchesContainer}>
      {children}
    </ul>
  );
});

export default MatchesContainer;
